import React from "react";
import { CalendarIcon } from "lucide-react";

/**
 * Reliable date field. Uses a native date input under the hood so it works
 * flawlessly inside Sheets/Dialogs, on mobile, and with the keyboard.
 * Value is always an ISO date string (YYYY-MM-DD).
 */
export const DatePicker = ({ value, onChange, testid, placeholder }) => {
  return (
    <div className="relative w-full">
      <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
      <input
        type="date"
        data-testid={testid}
        value={value || ""}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="flex h-10 w-full rounded-lg border border-input bg-background pl-9 pr-3 py-2 text-sm text-foreground ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [color-scheme:light] dark:[color-scheme:dark]"
      />
    </div>
  );
};
